<template>
  <nav aria-label="Page navigation">
    <ul class="pagination justify-content-between align-items-center">
      <li v-if="show_count" class="page-item">
        <div v-if="!display_light" class="d-flex align-items-center">
          <span class="d-none d-sm-inline-block text-body">{{from}} - {{to}} sur {{ items_count }}</span>
        </div>
      </li>

      <li class="page-item">
        <a class="page-link" href="javascript:void(0);" aria-label="Précédent" @click="$emit('prev_page')">
          <span aria-hidden="true">« Précédent</span>
          <span class="sr-only">Précédent</span>
        </a>
      </li>
      <li class="page-item">
        <div v-if="!display_light" class="d-flex align-items-center">
          <span class="d-none d-sm-inline-block text-body">Page:</span>
          <select class="custom-select custom-select-sm w-auto mx-2" @change="$emit('set_page', local_page)" v-model="local_page">
            <option v-for="index in page_count" :key="index" :value="index"> {{ index }} </option>
          </select>
          <span class="d-none d-sm-inline-block text-body">sur {{ page_count }}</span>
        </div>
      </li>
      <li class="page-item">
        <a class="page-link" href="javascript:void(0);" aria-label="Suivant" @click="$emit('next_page')">
          <span aria-hidden="true">Suivant »</span>
          <span class="sr-only">Suivant</span>
        </a>
      </li>
    </ul>
  </nav>
</template>


<script>

export default {

  props: {
    page: 0,
    page_count: 0,
    items_count: 0,
    from: 0,
    to: 0,
    show_count: false,
    display_light: false
  },

  data: function () {
    return {
      local_page: 1,
    }
  },

  watch: {
    page: function (new_val, old_val) {
      this.local_page = new_val;
    },
  },

  mounted() {
  },

  methods: {

    set_page: function () {
      if ( this.page > 0 && this.page <= this.page_count) {
        this.get_data()
      } else {
        this.page = 1
        this.get_data()
      }
    },


  }
}

</script>
